import React, { Component } from "react";

class Team extends Component {
  render() {
    const { boards = [] } = this.props;
    const { teamPageConfig } = this.props;
    const config = teamPageConfig || {};
    return (
      <div id="i_team" className="container mb-100">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title-area ltn__section-title-2--- text-center">
              <h1 className="section-title">
                {config?.title || "Yönetim Organizasyon"}
              </h1>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="ltn__team-details-member-info-details">
            <div className="row organizasyon-div">
              <div className="col-12">
                <div className="ltn__team-details-member-about row">
                  {boards.map((c) => (
                    <li
                      key={c.id}
                      className="col-lg-3"
                      style={{ marginTop: 50, listStyle: "none" }}
                    >
                      <strong>{c.name}</strong> <p>{c.title}</p>
                    </li>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Team;
